import { createSlice } from "@reduxjs/toolkit";
import { ISelectOption } from "src/@types/form";
import { getSoldInformationsReducer } from "./reducers";
import { SOLD_INFORMATIONS_SLICE_NAME } from "./actions";

export interface ISoldInformationsState {
  soldInformations: {
    isLoading: boolean;
    items: ISelectOption[];
  };
}

const initialState: ISoldInformationsState = {
  soldInformations: {
    isLoading: false,
    items: [],
  },
};

export const { reducer: soldInformations } = createSlice({
  name: SOLD_INFORMATIONS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getSoldInformationsReducer(builder);
  },
});
